import type { ICategory, ICategoryRaw } from '@/entities/category/model/types/categories';

export const modifyCategory = (category: ICategoryRaw): ICategory => ({
  id: category.id,
  parent_id: category.parent_id,
  name: category.name,
  slug: category.slug,
  ...(category.subcategories
    ? { subcategories: category.subcategories.map(modifyCategory) }
    : {}),
});

export const modifyCategories = (categories: ICategoryRaw[]): ICategory[] =>
  categories.map(modifyCategory);
